import { render } from "./ButtonSmallIcon.vue?vue&type=template&id=d95423fe"
import script from "./ButtonSmallIcon.vue?vue&type=script&lang=js"
export * from "./ButtonSmallIcon.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\Vue_Webinterface\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__